import { getEntityUpsertSession } from './EntityUpsertSessionContext';
import { buildRenderFieldLocals, createContentTypeHelpers } from './renderFieldLocals';
import { renderEntityUpsertFieldBody } from './renderEntityUpsertFieldBody';

/** Stable factory — reads current session from {@link entityUpsertSessionRef} on each field render. */
export function createEntityUpsertRenderField() {
    return (attr: Record<string, unknown>) => {
        const ctx = getEntityUpsertSession();
        const helpers = createContentTypeHelpers(ctx);
        const locals = buildRenderFieldLocals(attr, ctx);
        if (locals == null) return null;
        return renderEntityUpsertFieldBody(locals, helpers, attr);
    };
}

/** Singleton renderField for use inside {@link EntityUpsertSessionProvider}. */
export const entityUpsertRenderField = createEntityUpsertRenderField();
